import React from "react";

interface ConnectionSectionDescriptionProps {
    children: React.ReactNode;
}

const descriptionStyle: React.CSSProperties = {
    display: "block",
    marginTop: 6,
    marginBottom: 0,
    fontSize: 13,
    lineHeight: 1.5,
    color: "#000000",
    WebkitTextFillColor: "#000000",
    opacity: 1,
    maxWidth: 640,
    fontFamily: '"Nunito", sans-serif',
    fontWeight: 400,
};

const ConnectionSectionDescription: React.FC<
    ConnectionSectionDescriptionProps
> = ({ children }) => (
    <p className="connection-section-description" style={descriptionStyle}>
        {children}
    </p>
);

export default ConnectionSectionDescription;
